export default {
  branding: {
    'logo-black': '/assets/new/branding/logo-black@4x.png',
  },
  auth: {
    'login-truck': '/assets/new/auth/login-truck.png',
    'login-bg': '/assets/new/auth/login-bg.png',
  },
  barcode: {
    'barcode-mini-icon': '/assets/new/barcode/barcode-mini-icon.png',
    'barcode-info-zoom': '/assets/new/barcode/barcode-info-zoom.png',
  },
}
